module.exports = __webpack_public_path__ + "assets/list.76dedeca.svg";